import {StyleSheet, PixelRatio} from 'react-native';
export default StyleSheet.create({
    errorField:{
        alignItems:'center',
        justifyContent:'center'
    },
    errorImage:{
        width: '100%',
        height: 150
    },
    errorTipsField:{
        width: 161
    },
    errorTips:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 14,
        color: "#999999",
        letterSpacing: "0",
        textAlign: "center",
    },
    searchBoxVisible:{
        backgroundColor: "#f7f8fa"
    },
    container: {
        flex:1,
        backgroundColor: "#f7f8fa"
    },

    bgImage:{
        position: 'absolute',
        width: '100%'
    },

    content:{
        paddingTop: NOTCH_HEIGHT
    },

    topFixed:{
        position: 'absolute',
        backgroundColor: '#ffffff',
        paddingTop: NOTCH_HEIGHT,
        top:0,
        width:"100%",
        zIndex:100,
        display:'none',
        opacity:0
    },

    tabFixedShow:{
        display: 'flex',
        opacity: 1
    },

    welcome: {
        fontSize: 20,
        textAlign: 'center',
        margin: 10
    },

    instructions: {
        textAlign: 'center',
        color: '#333333',
        marginBottom: 5
    },

    ruleBtn: {
        backgroundColor: 'rgba(73, 73, 73, 0.5)',
        borderTopLeftRadius: 16,
        borderBottomLeftRadius: 16,
        paddingLeft: 8,
        paddingRight: 20,
        paddingVertical: 3,
        justifyContent: 'center',
        alignItems: 'center',
    },

    ruleBtnText: {
        color: '#fff',
        fontSize: 12,
        textAlign: 'center',
        includeFontPadding: false,
    }
});

import {NOTCH_HEIGHT} from "../../common/utils";
